import type { Scenario, Sizing } from "@/composables/forms/formTypes";
import { computed, ref } from "vue";
import { ToUnit } from "@/libs/units";
import type { UnitPresets } from "@/libs/units/presets";
import { loadUnitPreset } from "@/libs/units/presets";
import { useTargetUnits } from "./useTargetUnits";
import { Display_Units_Enum } from "gql/api";
import type { MaybeRef } from "@vueuse/core";

export const useScenarioUnits = (
  scenario: MaybeRef<Scenario | null | undefined>,
  sizing?: MaybeRef<Sizing | null | undefined>
) => {
  const _scenario = ref(scenario);
  const _sizing = ref(sizing);
  const unitPreset = computed(() =>
    loadUnitPreset(
      _sizing?.value?.default_display_units || Display_Units_Enum.UsOilField
    )
  );

  const getUnitByKey = (genericKey: keyof UnitPresets, overrideKey?: string) =>
    computed(() => {
      if (overrideKey) {
        const nonGenericUnit = ToUnit(
          _scenario.value?.display_unit_overrides?.[overrideKey]
        );
        if (nonGenericUnit) return nonGenericUnit;
      }

      const genericUnit = ToUnit(
        _scenario.value?.display_unit_overrides?.[genericKey]
      );
      if (genericUnit) return genericUnit;

      const sizingUnit = ToUnit(unitPreset.value[genericKey]);
      if (!sizingUnit) throw new Error("Unit Not Found");
      return sizingUnit;
    });

  const scenarioUnits = useTargetUnits(getUnitByKey);

  return {
    ...scenarioUnits
  };
};
